import { createElem, optionRow, bootstrapSwitchChange, addElement, createH3Label } from './util/form_fields.js';

var deleteCheckboxOption;
var createCheckboxOption;
$( document ).on('turbo:load', function () {
    if ($('.add-options').length > 0) {
        if($('.hidden_fields').length > 0){
            $('#options').collapse('show');
        }
        $('.published').bootstrapSwitch({onColor: 'success', offColor: 'warning'});
        $('.bootstrap-switch').css('vertical-align', 'bottom');
        var optionsCount = $('#options').data('options_count');

        deleteCheckboxOption = function deleteCheckboxOption(self) {
            self.parentNode.remove();
        };
        bootstrapSwitchChange($('.published'), 'checked', $('.add-options').data('type') == 'radio');

        createCheckboxOption = function createCheckboxOption() {
            if ($('#h3_options').length <= 0) {
                var h3 = createH3Label('Options', 'h3_options');
                addElement('options', h3);
            }
            var wrapper = optionRow();
            var row = createElem('div', ['row']);

            var checkedCol = createElem('div', ['col-sm-2']);
            var labelCol = createElem('div', ['col-sm-4']);
            var valueCol = createElem('div', ['col-sm-5']);

            var labelLabel = createElem('label');
            labelLabel.innerText = 'Label';
            var labelInput = createElem('input', ['form-control']);
            labelInput.type = 'text';
            labelInput.name = 'custom_form_field[options][' + optionsCount + '][label]';
            $(labelInput).attr('data-id', optionsCount);
            var checkedLabel = createElem('label');
            checkedLabel.innerText = 'Checked';
            var optionsCheckedHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#options').data('options-checked-help')});
            var optionsLabelHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#options').data('options-label-help')});
            var optionsValueHelpIcon = createElem('i', ['glyphicon', 'glyphicon-question-sign'], {'data-toggle': 'tooltip', 'data-placement': 'top', 'title': $('#options').data('options-value-help')});

            var checkbox = createElem('input', ['published']);
            checkbox.type = 'radio';
            checkbox.checked = false;
            $('.add-options').data('type') == 'radio' ? checkbox.name = 'groupSwitches' : '';

            $(checkbox).attr('data-id', optionsCount);

            var hiddenCheckbox = createElem('input', ['hidden_fields']);
            hiddenCheckbox.type = 'hidden';
            hiddenCheckbox.name = 'custom_form_field[options][' + optionsCount + '][checked]';
            hiddenCheckbox.value = 'false';
            $(hiddenCheckbox).attr('data-id', optionsCount);
            bootstrapSwitchChange(checkbox, 'checked', $('.add-options').data('type') == 'radio');

            var valueLabel = createElem('label');
            valueLabel.innerText = 'Value';
            var valueInput = createElem('input', ['form-control']);
            valueInput.type = 'text';
            valueInput.name = 'custom_form_field[options][' + optionsCount + '][value]';
            $(valueInput).attr('data-id', optionsCount);

            $(checkedCol).append(checkedLabel);
            $(checkedCol).append(' ');
            $(checkedCol).append(optionsCheckedHelpIcon);
            $(checkedCol).append(hiddenCheckbox);
            $(checkedCol).append(checkbox);
            $(checkbox).bootstrapSwitch({onColor: 'success', offColor: 'warning'});
            $(checkbox).css('vertical-align', 'bottom');
            $(row).append(checkedCol);

            $(labelCol).append(labelLabel);
            $(labelCol).append(' ');
            $(labelCol).append(optionsLabelHelpIcon);
            $(labelCol).append(labelInput);
            $(row).append(labelCol);

            $(valueCol).append(valueLabel);
            $(valueCol).append(' ');
            $(valueCol).append(optionsValueHelpIcon);
            $(valueCol).append(valueInput);
            $(row).append(valueCol);
            $(wrapper).append(row);

            $('#options_container').append(wrapper);
            optionsCount++;
        };

        $('.custom-form-field-form').submit(function () {
            $('.published').remove();
        });
    }
});
